import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const searchPublicosAlvo = term => {
  return api.http.get('/publicos_alvo')
}

export const getSelectPublicosAlvo = (term, callback) => {
  searchPublicosAlvo(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/publicosAlvo.js